module.exports = __webpack_public_path__ + "static/img/logo.88d09c77.svg";